import { useState } from "react";
import ProfileChangePopup from "components/profile/ProfileChangePopup";
import ProfileEditButton from "components/profile/ProfileEditButton";
import ProfileLogOut from "components/profile/ProfileLogOut";
import { createAPI } from "services/api/api";
import { useAuth0 } from "@auth0/auth0-react";
import ProfileResetPassword from "components/profile/ProfileResetPassword";
import { useDispatch } from "react-redux";
import { editUser } from "store/user";
import useProfile from "hooks/useProfile";
import { useSoundPath } from "hooks/useSoundPath";
import { updateProfileDataRequest } from "services/userFlagsService";


const Profile = () => {
  const api = createAPI();
  const dispatch = useDispatch();
  const profile = useProfile();
  const { getIdTokenClaims } = useAuth0();
  const [isChange, setIsChange] = useState(false);
  const [changeType, setChangeType] = useState("");
  const playsound = useSoundPath();

  const openChangePopup = (type) => {
    setIsChange(true);
    setChangeType(type);
    playsound("main");
  };

  const closeChangePopup = () => {
    setIsChange(false);
    setChangeType("");
    playsound("main");
  };

  const updateEmail = async (newEmail) => {
    playsound("main");
    try {
      await getIdTokenClaims().then(async (token) => {
        await api.patch(
          `https://${process.env.REACT_APP_AUTH0_DOMAIN}/me/update_email`,
          { email: newEmail },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch(editUser({ field: "email", value: newEmail }));
      });
    } catch (error) {
      console.log(error);
    }
  };

  const updateName = async (name, setStep, setIsLoading) => {
    playsound("main");
    try {
      setIsLoading(true);
      await updateProfileDataRequest({nickname: name});
      dispatch(editUser({ field: "nickname", value: name }));
      setStep("success");
    } catch (error) {
      console.error("Error updating name:", error);
      setStep("fail");
    } finally {
      setIsLoading(false);
    }
  };

  const updatePhoneNumber = async (newPhone, setStep, setIsLoading) => {
    playsound("main");
    try {
      setIsLoading(true);
      await updateProfileDataRequest({number: newPhone,});
      setStep("verification");
      dispatch(editUser({ field: "phone_number", value: newPhone }));
    } catch (error) {
      console.error("Error updating name:", error);
      setStep("fail");
    } finally {
      setIsLoading(false);
    }
  };

  const resetPassword = async (setStep, setIsLoading) => {
    try {
      setIsLoading(true);
      await api.post(
        `https://${process.env.REACT_APP_AUTH0_DOMAIN}/dbconnections/change_password`,
        {
          client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
          email: profile.email,
          connection: "Username-Password-Authentication",
        }
      );
      setStep("success");
    } catch (error) {
      console.error("Error of reset pasword:", error);
      setStep("fail");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <main className="profile-content">
      <form className="profile-form">
        <p className="profile-form__row">
          <span>Name</span>
          <b>{profile.name}</b>
        </p>
        <p className="profile-form__row">
          <span>Email address</span>
          <b>{profile.email}</b>
          <ProfileEditButton
            handler={() => {
              playsound("main");
              openChangePopup("email");
            }}
          />
        </p>
        <p className="profile-form__row">
          <span>Nickname (Optional)</span>
          <b>{profile.nickname || "Add name"}</b>
          {
            profile.auth_id.startsWith('auth0') &&
            <ProfileEditButton
              handler={() => {
                playsound("main");
                openChangePopup("real-name");
              }}
            />
          }
        </p>
        <p className="profile-form__row">
          <span>Phone Number</span>
          <b>{profile.phone_number || "Add phone"}</b>
          <ProfileEditButton
            handler={() => {
              playsound("main");
              openChangePopup("phone");
            }}
          />
        </p>
        <p className="profile-form__row">
          <span>Password</span>
          <input
            type="password"
            name="password"
            id="password"
            disabled
            value="********"
          />
          <ProfileResetPassword
            playSound={() => playsound("main")}
            resetPassword={resetPassword}
          />
        </p>

        <ProfileLogOut />
      </form>
      {isChange && (
        <ProfileChangePopup
          type={changeType}
          close={closeChangePopup}
          onUpdateEmail={updateEmail}
          onUpdateRealName={updateName}
          onUpdatePhoneNumber={updatePhoneNumber}
          onUpdatePassword={resetPassword}
        />
      )}
    </main>
  );
};

export default Profile;
